module.exports = __webpack_public_path__ + "img/wallet.fe45b7a7.png";